const translations = {
    day: {
        ar: "اليوم",
        da: "Dag",
        de: "Tag",
        en: "Day",
        es: "Día",
        fi: "Päivä",
        fr: "Jour",
        id: "Hari",
        it: "Giorno",
        ja: "日",
        ko: "일",
        ms: "Hari",
        nl: "Dag",
        pt: "Dia",
        ru: "День",
        th: "วัน",
        tr: "Gün",
        vi: "Ngày",
        zh: "活動日",
        "zh-hans": "活动日",
    },
    moreChicks: {
        ar: "فتافيت أكثر!",
        da: "Flere kyllinger!",
        de: "Mehr Küken!",
        en: "More Chicks!",
        es: "¡Más pollitos!",
        fi: "Lisää tipuja!",
        fr: "Plus de poussins !",
        id: "Lebih Banyak Anak Ayam!",
        it: "Altri pulcini!",
        ja: "ヒヨコンだもん！",
        ko: "더 많은 병아리!",
        ms: "Lebih Banyak Anak Ayam!",
        nl: "Meer kuikentjes!",
        pt: "Mais pintinhos!",
        ru: "Больше цыплят!",
        th: "มีลูกเจี๊ยบเพิ่ม!",
        tr: "Daha Fazla Civciv!",
        vi: "Nhiều Gà con hơn!",
        zh: "更多小雞！",
        "zh-hans": "更多小鸡！",
    },
} as const;

type TranslationKey = keyof typeof translations;
type Locale = keyof (typeof translations)[TranslationKey];

export function translate(key: TranslationKey, lang: string): string {
    const entry = translations[key];
    return (entry[lang as Locale] ?? entry.en) as string;
}
